import { Controller } from '@hotwired/stimulus';
import { toggleVisiblity } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'toggleHamburgerMenuContent',
    'toggleUserMenuContent',
    'toggleHamburgerMenuButton',
    'userMenu',
    'userMenuButton',
  ];

  static values = {
    userMenuExpanded: { type: Boolean, default: false },
    hamburgerMenuExpaned: { type: Boolean, default: false },
  }

  connect() {
    this.htmlRoot = document.querySelector('html');
    this.htmlRoot.addEventListener('click', this.handleRootClick.bind(this));
    this.setupWebflowIntgration()
  }

  setupWebflowIntgration() {
    if (this.isEmbeddedInWebflow()) {
      const document = window.top.document;
      const style = document.createElement('style');
      style.textContent = `
        .kr-prevent-scroll { overflow: hidden; }
        .kr-sticky-navbar {
          background: transparent;
          border: none;
          display: block;
          position: sticky;
          top: 0;
          width: 100%;
          z-index: 99999999999;
        }
      `;
      document.head.appendChild(style);

      window.frameElement.id = 'kr-embedded-navbar';
      window.frameElement.classList.add('kr-sticky-navbar');
      window.frameElement.style.height = `${this.element.offsetHeight}px`;
    }
  }

  updatePreventScrolling() {
    if (this.isEmbeddedInWebflow()) {
      const preventScrolling = this.hamburgerMenuExpanedValue || this.userMenuExpandedValue;

      window.top.document
        .querySelector('html')
        .classList.toggle('kr-prevent-scroll', preventScrolling);
    } else {
      const preventScrolling = this.hamburgerMenuExpanedValue || (this.userMenuExpandedValue && window.innerWidth <= 768);

      this.htmlRoot.classList.toggle('prevent-scroll', preventScrolling);
    }
  }

  toggleHamburgerMenu(event) {
    event.stopPropagation();

    this.hamburgerMenuExpanedValue = !this.hamburgerMenuExpanedValue;
    if(this.hamburgerMenuExpanedValue && this.userMenuExpandedValue) {
      this.userMenuExpandedValue = false;
    }

    this.updateMenus();
  }

  toggleUserMenu() {
    event.stopPropagation();

    this.userMenuExpandedValue = !this.userMenuExpandedValue;
    if(this.userMenuExpandedValue && this.hamburgerMenuExpanedValue) {
      this.hamburgerMenuExpanedValue = false;
    }

    this.updateMenus();
  }

  updateMenus() {
    if(this.hasUserMenuButtonTarget) {
      this.userMenuButtonTarget.classList.toggle('is-expanded', this.userMenuExpandedValue)
    }
    this.toggleHamburgerMenuButtonTarget.classList.toggle("navbar-component-hamburger-menu-button--hidden", this.hamburgerMenuExpanedValue);
    this.toggleHamburgerMenuContentTargets.forEach(element => {
      toggleVisiblity(element, this.hamburgerMenuExpanedValue);
    });
    this.toggleUserMenuContentTargets.forEach(element => {
      toggleVisiblity(element, this.userMenuExpandedValue);
    });

    this.updatePreventScrolling();
    this.updateWebflowIframeFullscreen();
  }

  handleRootClick(event) {
    if(!this.hasUserMenuButtonTarget) return true;
    if(!this.userMenuExpandedValue) return true;

    if(!this.userMenuTarget.contains(event.target) && event.target != this.userMenuButtonTarget && !this.userMenuButtonTarget.contains(event.target)) {
      this.toggleUserMenu();
    }
  }

  updateWebflowIframeFullscreen() {
    if (!this.isEmbeddedInWebflow()) return true;

    const shouldBeFullscreen = this.hamburgerMenuExpanedValue || this.userMenuExpandedValue;
    window.frameElement.classList.toggle('is-fullscreen', shouldBeFullscreen);

    if (shouldBeFullscreen) {
      window.frameElement.style.height = `${this.element.offsetHeight}px`;
      window.frameElement.style.position = null;
      window.top.document.body.style.paddingTop = null;
    } else {
      window.frameElement.style.height = '100%';
      window.frameElement.style.position = 'fixed';
      window.top.document.body.style.paddingTop = `${this.element.offsetHeight}px`;
    }
  }

  // This Component is used in 2 places.
  // a) This Rails App
  // b) As an iframe embed on our Webflow static pages
  //
  // For b) the code needs to do a bit of tweaking with its environment, so that
  // it is rendered approriately and integrates well into the webflow page.
  isEmbeddedInWebflow() {
    return window.top.__isWebflow == true;
  }
}
